import React, { useState } from "react";
import { Button, notification, Form, Input } from "antd";
import Screen from "../util/Extensions/Screens";
import RequestHandler from "../util/RequestHandler";

const ForgotPassword = (props) => {
  const [disabled, setDisabled] = useState(false);

  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: "BAŞARILI",
      description: "Şifre yenileme linkiniz mail adresinize gönderilmiştir.",
      duration: 2,
    });
  };

  const onFinishFailed = () => setDisabled(false);

  const onFinish = (values) => {
    setDisabled(true);
    RequestHandler.post(`/Auth/ForgotPassword`, {
      email: values.email,
      screenOption: Screen.screen,
    }).then((response) => {
      if (response.success) {
        openNotificationWithIcon("success");
        setTimeout(
          function () {
            props.history.push("/");
          }.bind(this),
          2000
        );
      } else {
        setDisabled(false);
      }
    });
  };

  return (
    <div className="gx-login-container" style={{ backgroundColor: "#f0f8ff" }}>
      <div className="gx-login-content">
        <div className="gx-login-header">
          {Screen.screen === 0 ? (
            <img
              src={require("assets/images/tahsilat-glass-logo-png.png")}
              alt="tahsilite"
              title="tahsilite"
              style={{ width: "40%" }}
            />
          ) : Screen.screen === 1 ? (
            <img
              src={require("assets/images/tahsilat-glass-logo-png.png")}
              alt="tahsilite"
              title="tahsilite"
              style={{ width: "40%" }}
            />
          ) : (
            <img
              src={require("assets/images/tahsilat-glass-logo-png.png")}
              alt="tahsilite"
              title="bakiyem"
              style={{ width: "40%" }}
            />
          )}
        </div>
        <div className="gx-mb-4">
          <h3>Şifreni mi unuttun ?</h3>
          <p>
            Mail adresinizi yazdığınız takdirde şifrenizi yenilemeniz için bir
            link gönderilecektir.
          </p>
        </div>
        <Form
          initialValues={{ remember: true }}
          name="basic"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          className="gx-signin-form gx-form-row0"
        >
          <Form.Item
            name="email"
            rules={[
              { required: true, message: "Lütfen mail adresinizi girin!" },
            ]}
          >
            <Input
              className="gx-input-lineheight"
              type="email"
              placeholder="Email adresinizi girin"
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" disabled={disabled}>
              Gönder
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default ForgotPassword;
